import { Moon, Sun } from 'lucide-react'
import { useThemeStore } from '../stores/useThemeStore'

interface ThemeToggleProps {
  className?: string
}

/** Light/dark toggle. Persists to localStorage and flips the `dark` class on <html>. */
export const ThemeToggle = ({ className = '' }: ThemeToggleProps) => {
  const theme = useThemeStore((s) => s.theme)
  const toggleTheme = useThemeStore((s) => s.toggleTheme)
  const isDark = theme === 'dark'

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      // min-w/h-10: p-2 around a 20px icon measures 36x36, under the 40px tap-target floor
      // the responsive audit enforces below 1024. The icon size is unchanged.
      className={`p-2 min-w-10 min-h-10 inline-flex items-center justify-center rounded-full text-foreground hover:bg-muted transition-colors ${className}`}
    >
      {isDark ? <Sun size={20} /> : <Moon size={20} />}
    </button>
  )
}
